import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import Help from '../../generics/help';

var Config = require('../../../config');

class LabelNumeric extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.searchUnit = this.searchUnit.bind(this);
        this.directPrint = this.directPrint.bind(this);

        this.state = {
            start_folio: "",
            end_folio: "",
            copies: "",

            preview_print: {}
        }
    }

    componentDidMount(){
        fetch(Config.default.apiGateway.URL+'functional_criterion?code=lab_preview_print',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				preview_print: response
			});
		});
    }

    handleChange(e) {
        this.setState({
			[e.target.name]: e.target.value
        });
        
        document.getElementById(e.target.name).classList.remove('error');
    }

    onKeyPress(e){
		if(e.key === 'Enter'){
            this.searchUnit();
		}
	}

    searchUnit() {
        var valid = true;
        var error = '';

        //Validar que al menos start_folio y copies tengan valor
        if(this.state.start_folio === "" || this.state.copies === ""){
            valid = false;
            error = 'Campos incompletos';

            if(this.state.start_folio === ""){                
                document.getElementById('start_folio').classList.add('error');
            }

            if(this.state.copies === ""){
                document.getElementById('copies').classList.add('error');
            }

        }else{
            var diff = (this.state.end_folio !== "" ? parseInt(this.state.end_folio) : 0) - (this.state.start_folio !== "" ? parseInt(this.state.start_folio) : 0);
        
            if(diff <= 100){
                valid = true;
            }else{
                valid = false;
                error = 'La diferencia entre número de folio no debe ser mayor a 100';
            }
        }        
        

        if(valid) {
            var data = {
                start_folio: this.state.start_folio,
                end_folio: this.state.end_folio,
                copies: this.state.copies,
                health_facilities_id: sessionStorage.getItem('health_facilities_id')
            }

            this.props.waiting.handleShow('Generando...');
            fetch(Config.default.apiGateway.URL+'labelsEditor/label_numeric', {
                method: 'POST',
                body: JSON.stringify(data),
                responseType:'blob',
                headers: new Headers({
                    'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                    'Content-Type'	: 'application/json'
                })
            }).then(res => {
                this.props.waiting.handleClose();
                if(res.ok) {
                    return res.blob();
                }
                else {
                    res.text().then(function(result) {
                        swal('¡Error!', result, 'error');
                        return;
                    });
                }
            }).then(response => {
                if(response !== undefined){
                    if(this.state.preview_print.value === "NO") {
                        //PREVIEW
                        var fileURL = URL.createObjectURL(response);
                        window.open(fileURL);
                    }
                    else {
                        this.directPrint(response);	
                    }
                }
            });
        }else{
            swal('Error', error, 'error');
        }
    }

    directPrint(response){
		//PRINTER
		var reader = new FileReader();
		reader.readAsDataURL(response); 
		reader.onloadend = ()=> {
			var base64data = reader.result;  
			var aux = base64data.split(',');
			this.props.socket.send('{"Operacion":"print", "Type":"label_numeric", "File": "'+aux[1]+'"}');
		}
	}

    render(){
		const {t} = this.props;

        return(
            <div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.warehouse.MAIN')} ->
						Etiqueta Numérica
					</h5>
				</div>
				<Help 
					{...this.props}
	                menu={"help_storage"} 
	                submenu={"help_label_numeric"}  />
                <form noValidate>
                    <fieldset className="col-xs-12 col-md-6 col-md-offset-3 form-group">
                        <div className="col-xs-12 col-md-3">
							<span className="span-min">Número desde</span>
							<input type="text" className="form-control" name="start_folio" id="start_folio" 
								value={this.state.start_folio} onChange={this.handleChange} onKeyPress={this.onKeyPress}  />
						</div>
                        <div className="col-xs-12 col-md-3">
							<span className="span-min">Número hasta</span>
							<input type="text" className="form-control" name="end_folio" id="end_folio" 
								value={this.state.end_folio} onChange={this.handleChange} onKeyPress={this.onKeyPress} />
						</div>
                        <div className="col-xs-12 col-md-3">
							<span className="span-min">Número copias</span>
							<input type="numeric" className="form-control" name="copies" id="copies" min="0" max="100"
								value={this.state.copies} onChange={this.handleChange} onKeyPress={this.onKeyPress} />
						</div>
                        <div className="col-xs-12 col-md-3" style={{paddingTop: "19px"}}>
                            <button type="button" className="btn btn-info" onClick={this.searchUnit} >
								Generar
							</button>
                        </div>
                    </fieldset>
                </form>
            </div>
        )
    }
}

export default translate('translations')(LabelNumeric);